export default __webpack_public_path__ + "static/media/calendar-dates.9ea28c7e.svg";